import { isModifiedEvent } from "@utils/helpers/functions";
import clsx from "clsx";
import { forwardRef } from "react";
import classes from "./BaseLink.module.scss";

const BaseLink = (
  props: React.AnchorHTMLAttributes<HTMLAnchorElement> & { navigate?: any },
  ref: React.LegacyRef<HTMLAnchorElement>
) => {
  const { className, navigate, children, onClick, ...rest } = props;

  const { target } = rest;

  const newProps = {
    ...rest,
    onClick: (event: any) => {
      try {
        if (onClick) onClick(event);
      } catch (ex) {
        event.preventDefault();
        throw ex;
      }

      if (
        !event.defaultPrevented && // onClick prevented default
        event.button === 0 && // ignore everything but left clicks
        (!target || target === "_self") && // let browser handle "target=_blank" etc.
        !isModifiedEvent(event) // ignore clicks with modifier keys
      ) {
        event.preventDefault();
        navigate();
      }
    },
  };

  return (
    <a ref={ref} className={clsx(classes["base-link"], className)} {...newProps}>
      {children}
    </a>
  );
};

export default forwardRef(BaseLink);
